import API from 'services/api';

interface IUpdateRatePlan {
  isActive: boolean;
}

export const updateRatePlan = ({
  ratePlanId,
  payload,
}: {
  ratePlanId: string;
  payload: IUpdateRatePlan;
}) => {
  return API.patch(`/api/accommodation/rate-plan/${ratePlanId}`, payload);
};
